import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(0),
    },
    submit: {
        margin: 0,
    },
    links: {
        marginTop: theme.spacing(1)
    },
    rightLink: {
        textAlign: 'right',
    },
    sectionTitle: {
        marginTop: theme.spacing(0),
    }
}));

const ForgotPasswordLink = () => (
    <Link to={'/forgot-password'} variant="body2">
        {"Forgot Password?"}
    </Link>
);

const INITIAL_STATE = {
    email: '',
    error: null,
};

const ForgotPassword = (props) => {
    const classes = useStyles();
    const [state, setState] = useState(INITIAL_STATE);

    const isInvalid = state.email === '';

    const handleChange = (e) => {
        setState({[e.target.name]: e.target.value})
    };

    const handleSubmit = (e) => {
        firebase.auth()
            .sendPasswordResetEmail(state.email)
            .then(() => {
                setState({...INITIAL_STATE});
            })
            .catch(error => {
                setState({error});
            });
        e.preventDefault();
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline/>
            <div className={classes.paper}>
                <Typography component="h6" variant="h6" className={classes.sectionTitle}>
                    Forgot Password?
                </Typography>
                <Typography component="h6" variant="h6" className={classes.sectionTitle}>
                    (This isn't working yet)
                </Typography>
                <form className={classes.form} noValidate onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                onChange={handleChange}
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                margin="dense"
                                value={state.email}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        id={"forget-password"}
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={isInvalid}
                        className={classes.submit}
                    >
                        Send a Reset Email
                    </Button>
                    {state.error && <p>{state.error.message}</p>}
                </form>
            </div>
        </Container>
    )
};

export {ForgotPassword, ForgotPasswordLink}
